module.exports = __webpack_public_path__ + "img/artlake.af2872df.png";